// src/services/api.service.ts
const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const apiEndpoints = {
  uploadLogo: `${API_BASE}/uploads/logo`,
  revshare: `${API_BASE}/api/revshare`,
  health: `${API_BASE}/health`,
};

export default API_BASE;